import { render, staticRenderFns } from "./BasicGrid.vue?vue&type=template&id=5cf0d07c"
import script from "./BasicGrid.vue?vue&type=script&lang=js"
export * from "./BasicGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports